import { InfoBox } from '@dealstack/frontend/shared/components/InfoBox/InfoBox.tsx';
import { useTranslationCommonUi } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { Text } from '@mantine/core';

interface Props {
	infoText?: string;
}

export const TaxDetailsHeader = ({ infoText }: Props) => {
	const tCommonUi = useTranslationCommonUi();

	return (
		<div>
			<Text size="B5Bold" mb="0.5rem">
				{tCommonUi('single_tax_details.tax')}
			</Text>

			<InfoBox
				iconVariant="information"
				description={infoText ?? tCommonUi('single_tax_details.info')}
			/>
		</div>
	);
};
